import { useState } from 'react';

const SERVICIOS = [
  { id: 'camarines',    label: 'Camarines',              icono: '🚿', desc: 'Vestuarios para ambos equipos'         },
  { id: 'duchas',       label: 'Duchas agua caliente',   icono: '🔥', desc: 'Agua caliente disponible'              },
  { id: 'iluminacion',  label: 'Iluminación nocturna',   icono: '💡', desc: 'LED para partidos de noche'            },
  { id: 'estacionamiento', label: 'Estacionamiento',     icono: '🚗', desc: 'Espacio para vehículos'                },
  { id: 'cafeteria',    label: 'Cafetería',              icono: '☕', desc: 'Bebidas y snacks disponibles'          },
  { id: 'petos',        label: 'Petos',                  icono: '👕', desc: 'Petos para diferenciar equipos'        },
  { id: 'pelota',       label: 'Pelota',                 icono: '⚽', desc: 'Pelota disponible para el partido'     },
  { id: 'enfermeria',   label: 'Primeros auxilios',      icono: '🏥', desc: 'Botiquín y atención básica'           },
  { id: 'wifi',         label: 'WiFi',                   icono: '📶', desc: 'Conexión a internet disponible'       },
  { id: 'transmision',  label: 'Transmisión en vivo',    icono: '📹', desc: 'Soporte para streaming del partido'   },
];

export default function StepServiciosRecinto({ datos, onNext, onBack }) {
  const [seleccionados, setSeleccionados] = useState(
    datos.servicios || []
  );
  const [error, setError] = useState('');

  const toggle = (id) => {
    setSeleccionados(prev =>
      prev.includes(id)
        ? prev.filter(s => s !== id)
        : [...prev, id]
    );
    setError('');
  };

  const handleNext = () => {
    if (seleccionados.length === 0) {
      setError('Selecciona al menos un servicio');
      return;
    }
    onNext({ servicios: seleccionados });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Servicios del recinto</h2>
      <p style={styles.sub}>
        Marca los servicios que ofreces. Esto aparecerá en tu perfil
        público y los equipos lo verán antes de reservar.
      </p>

      <div style={styles.grid}>
        {SERVICIOS.map(({ id, label, icono, desc }) => {
          const activo = seleccionados.includes(id);
          return (
            <div
              key={id}
              onClick={() => toggle(id)}
              style={{
                ...styles.card,
                border: `2px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                background: activo ? '#EFF5FF' : 'white',
              }}
            >
              <div style={styles.cardIcono}>{icono}</div>
              <div style={styles.cardInfo}>
                <div style={styles.cardLabel}>{label}</div>
                <div style={styles.cardDesc}>{desc}</div>
              </div>
              {activo && <div style={styles.check}>✓</div>}
            </div>
          );
        })}
      </div>

      <div style={styles.resumen}>
        {seleccionados.length} servicio{seleccionados.length !== 1 ? 's' : ''} seleccionado{seleccionados.length !== 1 ? 's' : ''}
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  grid: {
    display: 'flex', flexDirection: 'column',
    gap: 8, marginBottom: 16,
  },
  card: {
    display: 'flex', alignItems: 'center', gap: 12,
    borderRadius: 12, padding: '12px 14px',
    cursor: 'pointer', transition: 'all 0.12s',
    position: 'relative',
  },
  cardIcono: { fontSize: 20, flexShrink: 0 },
  cardInfo: { flex: 1 },
  cardLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 15, fontWeight: 700, color: '#141922', marginBottom: 1,
  },
  cardDesc: {
    fontSize: 11, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  check: {
    background: '#1A6BFF', color: 'white',
    width: 22, height: 22, borderRadius: '50%',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 11, fontWeight: 700,
    flexShrink: 0,
  },
  resumen: {
    fontSize: 13, fontWeight: 600,
    color: '#1A6BFF', fontFamily: "'Barlow', sans-serif",
    marginBottom: 16, textAlign: 'center',
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};